import request from "@/utils/request";

export function getTutorMessageList(key, page, size) {
  return request({
    url: `/api/Message/GetTutorMessageList?key=${key}&page=${page}&size=${size}&type=1`,
    method: "Post",
  });
}

export function getTutorWarningMessageList(type, key, page, size) {
  return request({
    url: `/api/Message/GetTutorMsgMessageList?key=${key}&page=${page}&size=${size}&type=${type}`,
    method: "Post",
  });
}

export function getTutorNoticeMessageList(type, key, page, size) {
  return request({
    url: `/api/Message/GetTutorMsgMessageList?key=${key}&page=${page}&size=${size}&type=${type}`,
    method: "Post",
  });
}

export function getTutorLevelMessageList(type, key, page, size) {
  return request({
    url: `/api/Message/getTutorLevelMessageList?key=${key}&page=${page}&size=${size}&type=${type}`,
    method: "Post",
  });
}

export function getMessageById(id) {
  return request({
    url: `/api/Message/GetMessageById?id=${id}`,
    method: "Post",
  });
}

export function getremindMessageById(id) {
  return request({
    url: `/api/Message/GetMessageRemindById?id=${id}`,
    method: "Post",
  });
}

export function batchSetReadedByMIds(data) {
  return request({
    url: "/api/Message/BatchSetReadedByMIds",
    method: "Post",
    data,
  });
}

export function batchSetReadedByType(type) {
  return request({
    url: `/api/Message/BatchSetReadedByType?type=${type}`,
    method: "Post",
  });
}

export function getTutorMoodleMsgList(limit, offset, start, end) {
  return request({
    url: "/api/Message/GetTutorMoodleMsgList",
    method: "Post",
    data: { start, end, limit, offset },
  });
}

/** SignalR 关闭时 HTTP 轮询兜底：未读数（Vue2 NotReadMsgCount） */
export function NotReadMsgCount() {
  return request({
    url: "/api/Message/NotReadMsgCount",
    method: "Post",
  });
}
